export default "__VITE_ASSET__KerkHi1Y__"